export enum PropertyType {
  Text,
  Number,
  Boolean,
  Indicator,
  Html,
  Date
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/PropertyType.ts